import apiService from 'src/shared/config/apiService';

export interface ImageSearchResult {
  url: string;
  [key: string]: any;
}

const S_IMAGE_SEARCH_PATH = '/s-image-search/';
const IMAGE_SEARCH_PATH = '/image-search/';

function normalizeImageSearchPayload(
  data: unknown,
  count: number
): ImageSearchResult[] {
  if (Array.isArray(data)) {
    return data.slice(0, count);
  }
  if (data && typeof data === 'object') {
    const record = data as {
      results?: ImageSearchResult[];
      images?: ImageSearchResult[];
    };
    const imageArray = record.results ?? record.images ?? [];

    return imageArray.slice(0, count);
  }

  return [];
}

/**
 * Tries SerpAPI image search first; on failure or empty results, falls back to Brave.
 */
const searchImages = async (
  query: string,
  count: number = 24
): Promise<ImageSearchResult[]> => {
  const params = { q: query, count };

  const trySoft = async (path: string): Promise<ImageSearchResult[]> => {
    try {
      const { data } = await apiService.get(path, { params });

      return normalizeImageSearchPayload(data, count);
    } catch {
      return [];
    }
  };

  const serpResults = await trySoft(S_IMAGE_SEARCH_PATH);

  if (serpResults.length > 0) {
    return serpResults;
  }

  try {
    const { data } = await apiService.get(IMAGE_SEARCH_PATH, { params });

    return normalizeImageSearchPayload(data, count);
  } catch (error: any) {
    const errorData = error?.response?.data ?? {};
    const errorMessage =
      errorData.error || errorData.message || 'Failed to fetch images';

    throw new Error(errorMessage);
  }
};

export default searchImages;
